import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import UserProfileCard from './UserProfileCard';
import SubTabs from './SubTabs ';
import InvoicePayment from './InvoicePayment';
import AboutMe from './AboutMe';
import { getDataWithToken, getMasterDataToken } from '../../../../Utils/restUtils';
import { useLocation, useNavigate } from 'react-router';
import { getMasterDetails, getMasterProfile } from '../../../../CommonURL';
import { useDispatch } from 'react-redux';
import Transparentspinner from '../../../Common/loader/Transparentspinner';

const UsersProfileContain = () => {


    // const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    // const location = useLocation();
    const [widgetDetails, setWidgetDetails] = useState({});
    const [personalDetails, setPersonalDetails] = useState({});
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userId = searchParams.get('id');
   useEffect(() => {
    if (userId) {
        masterWidgetData();
        masterUserData();
    }
}, [userId]);

   const masterWidgetData = async () => {
        setLoading(true);
        const response = await getMasterDataToken(`${getMasterDetails}?user_id=${userId}`);
        if (response?.data?.status === true){
          setWidgetDetails(response.data.data);
        } else if (response?.status >= 400 && response.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (response?.status >= 500 && response.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
        else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);

        }
        setLoading(false);
        
    }

    const masterUserData = async () => {
        setLoading(true);
        const response = await getMasterDataToken(`${getMasterProfile}?user_id=${userId}`);
         if (response?.data?.status === true){
            setPersonalDetails(response.data.data);        
            // const name= response?.data?.first_name+" "+response?.data?.last_name||''
            // dispatch(SetUserName(name))
        } else if (response?.status >= 400 && response.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (response?.status >= 500 && response.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
        else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);

        }
        setLoading(false);
    }


    // const fetchUserDetails = async (id) => {
    //     try {
    //         setLoading(true);
    //         const response = await getDataWithToken(`${getIndustryUser}?page=1&page_length=100`);
    //         const allUsers = response?.data?.users?.data || [];
    //         const user = allUsers.find((u) => String(u.id) === String(id));

    //         if (user) {
    //             setUserDetails(user);
    //         } else {
    //             console.warn("User not found for id:", id);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching user details:", error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    // if (loading) {
    //     return <Transparentspinner />;
    // }

    // if (!userDetails) {
    //     return <p className="text-center mt-5">No user details found.</p>;
    // }

   
    return (
        <Fragment>
            {loading && <Transparentspinner />}

            <Breadcrumbs
                mainTitle="User Profile"
                parent="Users"
                title="User Profile"
            />

            <Container fluid={true}>
                <div className="user-profile">
                    <Row>

                        {/* LEFT SIDE CARD */}
                        {Object.keys(widgetDetails).length > 0 && ( 
                            <UserProfileCard
                                details={widgetDetails} personalData={personalDetails}
                            />
                          )}  

                        {/* ABOUT ME */}
                        <Col xl="3" md="5" className="xl-35 box-col-30">
                            <div className="default-according style-1 faq-accordion job-accordion">
                                <Row>
                                    <Col xl='12'>
                                         {Object.keys(personalDetails).length > 0 && ( 
                                            <AboutMe fetchData={masterUserData} details={personalDetails} />
                                        )} 
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                        {/* RIGHT SIDE MAIN CONTENT */}
                         <Col xl="12" md="12" className="xl-65 box-col-70">
                            <Row>
                                <SubTabs param={{}} />
                            </Row>
                        </Col>

                        <InvoicePayment param={userId} />

                    </Row>
                </div>
            </Container>
        </Fragment>
    );
};

export default UsersProfileContain;
